import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../config/firebase';
import { verifyAdminToken } from '../services/adminAuth';
import { Loader } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';

const ProtectedRoute = ({ children }) => {
  const { isDarkMode } = useTheme();
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        setIsAuthenticated(true);
        
        try {
          const idToken = await user.getIdToken();
          const adminData = await verifyAdminToken(idToken, user.email);

          if (adminData) {
            setIsAdmin(true);
            sessionStorage.setItem('adminData', JSON.stringify(adminData));
          } else {
            setIsAdmin(false);
            sessionStorage.removeItem('adminData');
            await auth.signOut();
          }
        } catch (error) {
          console.error('Error verifying admin status:', error);
          setIsAdmin(false);
          sessionStorage.removeItem('adminData');
          await auth.signOut();
        }
      } else {
        setIsAuthenticated(false);
        setIsAdmin(false);
        sessionStorage.removeItem('adminData');
      }
      
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return (
      <div className={`min-h-screen flex items-center justify-center ${
        isDarkMode ? 'bg-fsgu-gray-900' : 'bg-fsgu-silver-50'
      }`}>
        <div className="text-center">
          <Loader className={`w-12 h-12 mx-auto mb-4 animate-spin ${
            isDarkMode ? 'text-fsgu-green-400' : 'text-fsgu-green-500'
          }`} />
          <p className={`text-lg ${
            isDarkMode ? 'text-fsgu-silver-400' : 'text-fsgu-silver-600'
          }`}>
            Verifying access...
          </p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated || !isAdmin) {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
};

export default ProtectedRoute;